import React from "react";

import Image from "next/image";

import EmpwrLogo from "public/images/logos/empwr-solar-logo.png";
import MomentumLogo from "public/images/logos/momentum-solar-logo.png";
import SoligoLogo from "public/images/logos/soligo-energy-logo.png";
import SunPowerLogo from "public/images/logos/sunpower-logo.png";
import ZeoLogo from "public/images/logos/zeo-energy-logo.png";

import Heading from "components/heading";
import HeroSection from "components/hero-section";

import styles from "./index.module.css";

const title = "Trusted by Leading Residential Solar Companies";

const BiggestNamesInSolar = () => (
  <div className="bg-gray-100">
    <HeroSection title={title}>
      <HeroSection.Content>
        <HeroSection.Header>
          <Heading tag="h5">{title}</Heading>
        </HeroSection.Header>

        <div className="flex justify-center sm:justify-between flex-wrap md:flex-nowrap -mx-2 -mt-2">
          <div className={styles.logoItem}>
            <Image src={MomentumLogo} alt="Logo - Momentum Solar" />
          </div>
          <div className={styles.logoItem}>
            <Image src={EmpwrLogo} alt="Logo - Empwr Solar" />
          </div>
          <div className={styles.logoItem}>
            <Image src={SunPowerLogo} alt="Logo - SunPower" />
          </div>
          <div className={styles.logoItem}>
            <Image src={ZeoLogo} alt="Logo - Zeo Energy Solar" />
          </div>
          <div className={styles.logoItem}>
            <Image src={SoligoLogo} alt="Logo - Soligo Energy Solar" />
          </div>
        </div>
      </HeroSection.Content>
    </HeroSection>
  </div>
);

export default BiggestNamesInSolar;
